import { useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";

import { motion } from "framer-motion";
import axiosToken from "../../api/axiosClient";
import { toast } from "react-toastify";
import logo200 from "../../assets/logo/logo-200.png";

const ForgotPasswordPage = ({ defaultValue = "" }) => {
  const navigate = useNavigate();
  const { callback } = useParams(); // récupère callback dynamique depuis l'URL
  const [loading, setLoading] = useState(false);

  const emailRef = useRef(null);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: defaultValue || "",
    },

    validationSchema: Yup.object({
      email: Yup.string().email("Email invalide").required("Email requis"),
    }),
    onSubmit: async (values) => {
      setLoading(true);

      // Envoi du code OTP
      try {
        const data = {
          email: values.email,
        };
        const response = await axiosToken.post("/auth/forgot-password", data);
        if (response?.data?.success === true) {
          toast.success(
            response?.data?.message || "Code de reinitialisation envoyé."
          );

          emailRef.current?.blur();
          sessionStorage.setItem("forgot-email", values.email);

          navigate(`/reset-password/${callback || ""}`);
        } else {
          toast.error(
            response?.data?.message ||
              "Echec d'envoi du code de réinitialisation"
          );
        }
      } catch (error) {
        console.error(
          "Echec d'envoi du code de réinitialisation. Erreur: ",
          error
        );
        toast.error(
          error?.response?.data?.error ||
            "Echec d'envoi du code de réinitialisation"
        );
      }

      return;
    },
  });

  document.title = "Mot de passe oublié || Barberlys";

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-12">
      <div className="w-full bg-white max-w-xl shadow-xl p-8">
        {/* Header */}
        <div className="mb-6 text-center">
          {/* <span className="text-sm bg-secondary-50 text-secondary-700 px-3 py-1 font-medium">
            Mot de passe oublié ?
          </span> */}
          <Link to={`/index`} className="cursor-pointer">
            <img src={logo200} className="m-auto" />
          </Link>
          <h2 className="text-2xl font-semibold mt-3">
            Réinitialisation de mot de passe
          </h2>
        </div>

        {/* Form */}
        <form onSubmit={formik.handleSubmit} className="">
          <motion.div
            key="step1"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 50 }}
            transition={{ duration: 0.4 }}
          >
            <div className="space-y-5">
              <div className="space-y-1">
                <input
                  ref={emailRef}
                  type="email"
                  name="email"
                  placeholder="Adresse email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  // autoFocus={true}
                  className="w-full placeholder-gray-400 px-4 py-2 shadow focus:outline-none focus:ring-2 focus:ring-gray-500"
                />
                {formik.touched.email && formik.errors.email && (
                  <p className="text-red-400 text-sm">{formik.errors.email}</p>
                )}
              </div>

              <div className="flex justify-between items-center mb-6">
                {/* Button retour  */}
                <button
                  type="button"
                  onClick={() => {
                    navigate(-1);
                  }}
                  className="bg-black text-white py-2 px-4 shadow hover:bg-gray-500 font-semibold transition-all"
                >
                  Retour
                </button>

                <button
                  disabled={!(formik.isValid && formik.dirty) || loading}
                  type="submit"
                  className={`bg-secondary-300 ${
                    !(formik.isValid && formik.dirty)
                      ? ""
                      : " hover:bg-secondary-400"
                  } text-white py-2 px-4 font-semibold transition-all`}
                >
                  {loading ? (
                    <div className="flex flex-row justify-center items-center gap-2">
                      <div className="animate-spin rounded-full h-4 w-4 border-t-4 border-b-4 border-white" />
                      <span>Envoi...</span>
                    </div>
                  ) : (
                    "Continuer"
                  )}
                </button>
              </div>
            </div>
          </motion.div>

          {/* Lien vers la page de connexion */}

          <p className="text-center text-sm text-gray-300 mt-4">
            <Link
              to="/login"
              className="text-secondary hover:text-secondary-700"
            >
              Je connais mon mot de passe {/* se connecter */}
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
